<template>
  <div style="text-align:left;">
    <TopNav />
    <div class="column-left">
      <SideNav />
    </div>

    <ModalTransferir
      ref="modaltransferir"
      :pagos_="modalData.pagos"
      :tipos_de_cuenta_="modalData.tipos_de_cuenta"
      :bancos_="modalData.bancos"
      :monto_a_transferir="modalData.monto"
      :profesional_="modalData.profesional"
    />



    <div v-if="refundCreateModal.show && refundCreateModal.wrap" class="confirm-overlay">
      <div class="confirm-modal refund-modal">
        <h4>Crear reembolso</h4>
        <p class="refund-modal-summary">
          Pago <strong>#{{ refundCreateModal.wrap.pago.id }}</strong>
          · Orden #{{ refundCreateModal.wrap.pago.orden_id }}
          · Disponible ${{ formatCurrency(refundCreateModal.wrap.remaining_refundable_amount || 0) }}
        </p>
        <div class="refund-modal-grid">
          <label>
            <span>Monto a reembolsar</span>
            <input
              v-model.number="refundCreateForm.monto"
              type="number"
              min="1"
              :max="Number(refundCreateModal.wrap.remaining_refundable_amount || 0)"
            >
          </label>
          <label>
            <span>Email cliente</span>
            <input v-model.trim="refundCreateForm.email_cliente" type="email" placeholder="Opcional">
          </label>
        </div>
        <label class="refund-modal-field">
          <span>Motivo</span>
          <input v-model.trim="refundCreateForm.motivo" type="text" placeholder="Motivo del reembolso">
        </label>
        <label class="refund-modal-field">
          <span>Notas internas</span>
          <textarea v-model.trim="refundCreateForm.notas_internas" rows="3" placeholder="Notas internas"></textarea>
        </label>
        <label class="refund-modal-checkbox">
          <input v-model="refundCreateForm.send_email" type="checkbox">
          Enviar correo al cliente al crear
        </label>
        <div class="confirm-actions">
          <button class="confirm-cancel-btn" :disabled="refundCreateSubmitting" @click="closeRefundCreateModal">Cancelar</button>
          <button class="confirm-ok-btn" :disabled="refundCreateSubmitting" @click="submitRefundCreate">
            {{ refundCreateSubmitting ? 'Guardando...' : 'Crear reembolso' }}
          </button>
        </div>
      </div>
    </div>

    <div class="column-right">
      <div v-if="admin_datos.superadmin" class="main-container">
        <div v-if="loaded" class="articulo-principal">
          <div class="top-actions">
            <button class="btn btn-std" @click="downloadCSV()" :disabled="!selectedPaymentIds.length">
              Descargar CSV Transferencia Masiva <b-icon icon="download"></b-icon>
            </button>
          </div>
          <div class="table-shell">
            <table class="main-table">
              <thead>
                <tr>
                  <th style="width:52px"></th>
                  <th>Profesional</th>
                  <th>Venta</th>
                  <th>A transferir</th>
                  <th style="width:160px">Acción</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="prof in profesionales">
                  <tr :key="`prof-${prof.profesional.id}`" class="professional-row">
                    <td>
                      <button class="expand-btn" @click="toggleProfesional(prof.profesional.id)">
                        {{ isExpanded(prof.profesional.id) ? '−' : '+' }}
                      </button>
                    </td>
                    <td>
                      <div class="professional-cell">
                        <img :src="prof.profesional.foto" :alt="prof.profesional.nombre" class="person-img">
                        <div>
                          <div class="prof-name">
                            {{ prof.profesional.nombre }} {{ prof.profesional.apellido }}
                            <span :class="getTipoPrestadorBadgeClass(prof.profesional.tipo_prestador_tributario)">
                              {{ formatTipoPrestadorTributario(prof.profesional.tipo_prestador_tributario) }}
                            </span>
                            <span
                              v-if="isIndependentProfessional(prof)"
                              :class="getSiiVerificationBadgeClass(prof.profesional.bhe_autorizacion_estado)"
                            >
                              {{ formatSiiVerificationBadge(prof.profesional.bhe_autorizacion_estado) }}
                            </span>
                          </div>
                          <div class="prof-meta">ID #{{ prof.profesional.id }}</div>
                        </div>
                      </div>
                    </td>
                    <td>${{ formatCurrency(prof.monto_total_ordenes) }}</td>
                    <td>
                      <div>${{ formatCurrency(getMontoTransferible(prof)) }}</div>
                      <div v-if="getProfBheRetencionTotal(prof) > 0" class="amount-hint amount-hint-warning">
                        Retencion BHE: -${{ formatCurrency(getProfBheRetencionTotal(prof)) }}
                      </div>
                      <div v-if="Number(prof.refund_outstanding_balance || 0) > 0" class="amount-hint amount-hint-warning">
                        Arrastre reembolsos: -${{ formatCurrency(prof.refund_outstanding_balance) }}
                      </div>
                    </td>
                    <td>
                      <button
                        class="transfer-btn"
                        :disabled="getMontoTransferible(prof) <= 0"
                        @click="openTransferModal(prof)"
                      >
                        Transferir
                      </button>
                    </td>
                  </tr>

                  <tr v-if="isExpanded(prof.profesional.id)" :key="`detail-${prof.profesional.id}`" class="detail-row">
                    <td colspan="5" class="detail-container">
                      <div v-if="!groupedByOrder(prof).length" class="muted">No hay pagos pendientes.</div>

                      <section
                        v-for="group in groupedByOrder(prof)"
                        :key="`orden-${prof.profesional.id}-${group.orden.id}`"
                        class="order-card"
                      >
                        <div class="order-header">
                          <div>
                            <h4>
                              <router-link
                                class="inline-detail-link"
                                :to="`/OrdenDetalleAdmin/${group.orden.id}`"
                              >
                                Orden #{{ group.orden.id }}
                              </router-link>
                            </h4>
                            <p>
                              <router-link
                                v-if="getClienteId(group.orden)"
                                class="inline-detail-link"
                                :to="`/superadmin/Usuarios/${getClienteId(group.orden)}`"
                              >
                                {{ getClienteNombre(group.orden) }}
                              </router-link>
                              <span v-else>{{ getClienteNombre(group.orden) }}</span>
                              · {{ group.orden.direccion }}
                            </p>
                          </div>
                          <div class="order-total">
                            Total orden seleccionado: ${{ formatCurrency(getOrderTransferible(group)) }}
                            <div v-if="getOrderBheRetencionTotal(group) > 0" class="amount-hint amount-hint-warning">
                              Retencion BHE orden: -${{ formatCurrency(getOrderBheRetencionTotal(group)) }}
                            </div>
                          </div>
                        </div>

                        <div v-if="Number(prof.refund_outstanding_balance || 0) > 0" class="order-warning">
                          Este profesional tiene un saldo negativo pendiente por reembolsos de ${{ formatCurrency(prof.refund_outstanding_balance) }}.
                          Se descuenta al transferir.
                        </div>

                        <div v-if="isOrderBlocked(group)" class="order-warning">
                          Regla aplicada: único pago menor a $25.000 sin presupuesto. Se desmarca por defecto.
                        </div>
                        <div v-if="isOrderBlocked(group) && hasCheckedBlockedPayments(group)" class="order-warning order-warning-strong">
                          Atención: seleccionaste un pago que no cumple la regla de $25.000 sin presupuesto.
                        </div>
                        <div v-if="isPresupuestoNoRequerido(group)" class="order-info">
                          Esta orden fue marcada como <strong>"Presupuesto no requerido"</strong>, por eso sus pagos se seleccionan por defecto.
                        </div>
                        <div v-else-if="isPurchasedSolicitud(group)" class="order-info">
                          El profesional compró esta solicitud, por lo que no necesita enviar un presupuesto para transferir.
                        </div>

                        <div class="grid-two">
                          <div class="detail-card">
                            <h5>Presupuestos</h5>
                            <ul v-if="group.orden.presupuestos && group.orden.presupuestos.length" class="clean-list">
                              <li v-for="pres in group.orden.presupuestos" :key="`pres-${pres.id}`">
                                {{ formatDate(pres.fecha_creado) }} · ${{ formatCurrency(pres.monto_total) }} · {{ estado_presupuestos[pres.estado] || pres.estado }}
                              </li>
                            </ul>
                            <div v-else class="muted">Sin presupuestos.</div>
                          </div>

                          <div class="detail-card">
                            <h5>Boletas / Facturas</h5>
                            <div v-if="getDocumentosServicio(group).length">
                              <ul class="clean-list">
                                <li v-for="doc in getDocumentosServicio(group)" :key="`doc-${doc.id}`" class="doc-row">
                                  <span>{{ formatDate(doc.fecha_creado) }} · <strong>{{ doc.tipo_documento === 'factura' ? 'Factura' : 'Boleta' }}</strong> · ${{ formatCurrency(doc.monto) }}</span>
                                  <button class="doc-link-btn" @click="abrirDocumento(doc)">Ver archivo</button>
                                </li>
                              </ul>
                              <div class="doc-total">Suma documentos: ${{ formatCurrency(group.orden.documentos_servicio_total || 0) }}</div>
                            </div>
                            <div v-else-if="!groupHasEmittedBhe(group)" class="doc-warning">
                              No hay boleta/factura asociada a esta orden.
                            </div>
                            <div v-else class="muted">
                              Sin documentos manuales asociados.
                            </div>
                            <div v-if="isIndependentProfessional(prof)" class="doc-section bhe-section">
                                <ul v-if="getGroupBheRows(group).length" class="clean-list bhe-list">
                                  <li v-for="row in getGroupBheRows(group)" :key="`bhe-${group.orden.id}-${row.pago_id || (row.pago && row.pago.id)}`" class="bhe-row">
                                    <div>
                                      <div class="bhe-row-title">
                                        Pago #{{ row.pago_id || (row.pago && row.pago.id) }}
                                        <span :class="getBheEmissionBadgeClass(row.estado)">{{ formatBheEmissionStatus(row.estado) }}</span>
                                      </div>
                                      <div class="amount-hint">
                                        Honorarios: ${{ formatCurrency(row.monto_honorarios_bruto || row.service_value || 0) }}
                                        · Retencion SII: ${{ formatCurrency(getBheRetencionMontoInformativo(row)) }}
                                        <span v-if="!bheRetencionJobbingEnabled">(la paga el profesional)</span>
                                        · Liquido BHE: ${{ formatCurrency(row.monto_liquido || row.monto_neto_post_bhe_display || 0) }}
                                      </div>
                                      <div v-if="row.error_mensaje" class="amount-hint amount-hint-warning">
                                        {{ row.error_mensaje }}
                                      </div>
                                    </div>
                                    <button
                                      v-if="row.pdf_url"
                                      class="doc-link-btn"
                                      @click="openBhePdf(row)"
                                    >
                                      Ver PDF
                                    </button>
                                  </li>
                                </ul>
                                <div v-else class="doc-warning">
                                  No hay BHE registradas todavía para los pagos de esta orden.
                                </div>
                              </div>
                              <div v-if="false" class="doc-info">
                                Este profesional opera como empresa. Aquí aplican boletas o facturas manuales, no BHE emitida por Jobbing.
                              </div>
                              <div v-if="false" class="doc-warning">
                                Falta clasificar tributariamente al profesional para saber si corresponde BHE o documento manual.
                              </div>
                            </div>
                          </div>
                          
                          <div class="detail-card">
                            <h5>Ítems de la orden</h5>
                            <table class="inner-table">
                              <tbody>
                                <tr class="labels-row">
                                  <td><strong>Nombre</strong></td>
                                  <td><strong>Precio</strong></td>
                                  <td><strong>¿Insumo?</strong></td>
                                  <td><strong>% pagado</strong></td>
                                  <td><strong>Documento</strong></td>
                                </tr>
                                <tr v-for="item in group.orden.items || []" :key="`item-${item.id}`">
                                  <td>{{ item.nombre }}</td>
                                  <td>${{ formatCurrency(item.precio) }}</td>
                                  <td>
                                    <span :class="item.es_insumo === 1 ? 'badge badge-insumo' : 'badge badge-no-insumo'">
                                      {{ item.es_insumo === 1 ? 'Sí' : 'No' }}
                                    </span>
                                  </td>
                                  <td>
                                    <span :class="getPorcentajeBadgeClass(item.id, item.precio, group)">
                                      {{ getItemPorcentajePagado(item.id, item.precio, group) }}
                                    </span>
                                  </td>
                                  <td>
                                    <span :class="getDocumentoBadgeClass(item.id, group)">
                                      {{ getItemDocumento(item.id, group) }}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        

                        <div class="detail-card payment-card">
                          <h5>Pagos</h5>
                          <table class="inner-table payments-table">
                            <tbody>
                              <tr class="labels-row">
                                <td></td>
                                <td><strong>ID</strong></td>
                                <td><strong>Método</strong></td>
                                <td><strong>Fecha</strong></td>
                                <td><strong>Venta</strong></td>
                                <td><strong>A transferir</strong></td>
                                <td><strong>Acción</strong></td>
                              </tr>
                              <tr v-for="wrap in group.pagos" :key="`pago-${wrap.pago.id}`">
                                <td>
                                  <input
                                    type="checkbox"
                                    v-model="wrap.checked"
                                    :disabled="Number(wrap.monto_neto_ajustado_display || 0) <= 0"
                                  >
                                </td>
                                <td>#{{ wrap.pago.id }}</td>
                                <td>{{ wrap.pago.metodo_pago || '-' }}</td>
                                <td>{{ formatDateFromBackend(wrap.pago.fecha_pagado) }}</td>
                                <td>
                                  <div>${{ formatCurrency(wrap.pago.monto) }}</div>
                                  <div v-if="hasPaymentDiscount(wrap)" class="payment-discount-hint">
                                    Descuento: -${{ formatCurrency(getPaymentDiscountAmount(wrap)) }}
                                  </div>
                                  <div v-if="hasPaymentDiscount(wrap)" class="amount-hint">
                                    {{ getPaymentDiscountLabel(wrap) }}
                                    <span v-if="getPaymentDiscountSubtotal(wrap) > 0">
                                      - Subtotal ${{ formatCurrency(getPaymentDiscountSubtotal(wrap)) }}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <div>${{ formatCurrency(wrap.monto_neto_ajustado_display || 0) }}</div>
                                  <div v-if="Number(wrap.commission_amount || 0) > 0" class="amount-hint commission-hint">
                                    Comisión Jobbing: -${{ formatCurrency(wrap.commission_amount || 0) }}
                                  </div>
                                  <div v-if="Number(wrap.commission_on_insumos || 0) > 0" class="amount-hint">
                                    Materiales {{ formatPercent(wrap.materials_commission_rate) }}: -${{ formatCurrency(wrap.commission_on_insumos || 0) }}
                                  </div>
                                  <div v-if="wrap.purchased_solicitud_commission_applied" class="amount-hint">
                                    Solicitud comprada: {{ formatPercent(wrap.purchased_solicitud_commission_rate) }} sobre servicio
                                  </div>
                                  <div v-if="Number(wrap.bhe_retencion_monto || 0) > 0" class="amount-hint amount-hint-warning">
                                    Retencion BHE: -${{ formatCurrency(wrap.bhe_retencion_monto) }}
                                  </div>
                                  <div v-else-if="!bheRetencionJobbingEnabled && Number(wrap.bhe_retencion_monto_calculado || 0) > 0" class="amount-hint">
                                    Retencion BHE: ${{ formatCurrency(wrap.bhe_retencion_monto_calculado) }} a cargo del profesional
                                  </div>
                                  <div v-if="Number(wrap.refund_reserved_professional_impact || 0) > 0" class="amount-hint amount-hint-warning">
                                    Reserva reembolso: -${{ formatCurrency(wrap.refund_reserved_professional_impact) }}
                                  </div>
                                  <div class="amount-hint">
                                    Neto base: ${{ formatCurrency(wrap.monto_neto_display || 0) }}
                                  </div>
                                  <div v-if="Number(wrap.monto_neto_post_bhe_display || 0) !== Number(wrap.monto_neto_display || 0)" class="amount-hint">
                                    Neto post BHE: ${{ formatCurrency(wrap.monto_neto_post_bhe_display || 0) }}
                                  </div>
                                </td>
                                <td>
                                  <button
                                    class="refund-btn"
                                    :disabled="Number(wrap.remaining_refundable_amount || 0) <= 0"
                                    @click="openRefundCreateModal(wrap)"
                                  >
                                    Crear reembolso
                                  </button>
                                  <div class="refund-inline-meta">
                                    Cliente: ${{ formatCurrency(wrap.remaining_refundable_amount || 0) }}
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </section>
                    </td>
                  </tr>
                </template>

                <tr class="total-row">
                  <td colspan="2"><strong>Total general</strong></td>
                  <td><strong>${{ formatCurrency(totalVenta) }}</strong></td>
                  <td><strong>${{ formatCurrency(totalAPagar) }}</strong></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>

        <div v-else class="articulo-principal">Cargando...</div>
      </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import SideNav from '@/components/SideNav.vue';
import TopNav from '@/components/TopNav.vue';
import ModalTransferir from '@/views/superadmin/ModalTransferir.vue';

export default {
  name: 'PagosSuperadmin',
  components: { SideNav, TopNav, ModalTransferir },
  data() {
    return {
      loaded: false,
      profesionales: [],
      expandedProfesionales: {},
      bheRetencionJobbingEnabled: false,
      bancos: [],
      tipos_de_cuenta: [],
      modalData: {
        profesional: {},
        pagos: [],
        bancos: [],
        tipos_de_cuenta: [],
        monto: 0,
      },
      refundCreateModal: {
        show: false,
        wrap: null,
      },
      refundCreateSubmitting: false,
      refundCreateForm: {
        monto: null,
        motivo: '',
        notas_internas: '',
        email_cliente: '',
        send_email: true,
      },
      estado_presupuestos: { 1: 'Enviado', 2: 'Aprobado' },
    };
  },
  created() {
    this.initialize_();
  },
  methods: {
    ...mapActions(['initialize']),
    formatCurrency(value) {
      return Intl.NumberFormat('de-DE').format(Number(value || 0));
    },
    formatPercent(value) {
      const numeric = Number(value || 0);
      return `${(numeric * 100).toLocaleString('es-CL', { maximumFractionDigits: 2 })}%`;
    },
    formatDate(value) {
      return value ? new Date(value).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' }) : '-';
    },
    formatDateFromBackend(fecha) {
      if (!fecha) return '-';
      if (typeof fecha === 'object' && fecha.y && fecha.m && fecha.d) {
        return new Date(fecha.y, fecha.m - 1, fecha.d).toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' });
      }
      return this.formatDate(fecha);
    },
    isExpanded(id) {
      return !!this.expandedProfesionales[id];
    },
    toggleProfesional(id) {
      this.$set(this.expandedProfesionales, id, !this.expandedProfesionales[id]);
    },
    groupedByOrder(prof) {
      const groups = {};
      (prof.pagos || []).forEach((wrap) => {
        const orderId = wrap.pago.orden_id;
        if (!groups[orderId]) {
          groups[orderId] = { orden: wrap.orden, pagos: [] };
        }
        groups[orderId].pagos.push(wrap);
      });
      return Object.values(groups);
    },
    getClienteId(orden) {
      return (orden && (orden.cliente_id || (orden.usuario && orden.usuario.id))) || null;
    },
    getClienteNombre(orden) {
      if (!orden) {
        return '-';
      }
      return [orden.nombre, orden.apellido1].filter(Boolean).join(' ') || '-';
    },
    getDocumentosServicio(group) {
      return (group.orden && group.orden.documentos_servicio) || [];
    },
    getPaymentDiscount(wrap) {
      return wrap && wrap.descuento ? wrap.descuento : null;
    },
    hasPaymentDiscount(wrap) {
      return this.getPaymentDiscountAmount(wrap) > 0;
    },
    getPaymentDiscountAmount(wrap) {
      const descuento = this.getPaymentDiscount(wrap);
      return descuento ? Number(descuento.monto_descuento || 0) : 0;
    },
    getPaymentDiscountSubtotal(wrap) {
      const descuento = this.getPaymentDiscount(wrap);
      return descuento ? Number(descuento.subtotal || 0) : 0;
    },
    getPaymentDiscountLabel(wrap) {
      const descuento = this.getPaymentDiscount(wrap);
      if (!descuento) {
        return '';
      }
      const regla = descuento.regla || {};
      const name = descuento.regla_nombre || regla.nombre || descuento.codigo_usado || descuento.regla_codigo;
      return name ? `Descuento ${name}` : 'Descuento aplicado';
    },
    isIndependentProfessional(prof) {
      return !!(prof && prof.profesional && prof.profesional.tipo_prestador_tributario === 'independiente');
    },
    isEmpresaProfessional(prof) {
      return !!(prof && prof.profesional && prof.profesional.tipo_prestador_tributario === 'empresa');
    },
    shouldRequireBheForTransfer(prof) {
      return this.bheRetencionJobbingEnabled && this.isIndependentProfessional(prof);
    },
    getTipoPrestadorBadgeClass(value) {
      if (value === 'independiente') return 'badge badge-yellow professional-tax-badge';
      if (value === 'empresa') return 'badge badge-green professional-tax-badge';
      return 'badge badge-gray professional-tax-badge';
    },
    getSiiVerificationBadgeClass(value) {
      if (value === 'autorizacion_verificada') return 'badge badge-green professional-tax-badge';
      if (value === 'autorizacion_fallida' || value === 'autorizacion_expirada' || value === 'autorizacion_revocada_o_invalida') {
        return 'badge badge-red professional-tax-badge';
      }
      return 'badge badge-gray professional-tax-badge';
    },
    formatSiiVerificationBadge(value) {
      if (value === 'autorizacion_verificada') return 'SII verificado';
      if (value === 'autorizacion_fallida' || value === 'autorizacion_expirada' || value === 'autorizacion_revocada_o_invalida') {
        return 'SII no verificado';
      }
      return 'SII pendiente';
    },
    formatTipoPrestadorTributario(value) {
      if (value === 'independiente') return 'Independiente';
      if (value === 'empresa') return 'Empresa';
      return 'Clasificación pendiente';
    },
    formatBheAuthorizationStatus(value) {
      const labels = {
        pendiente_autorizacion_sii: 'Pendiente autorización SII',
        autorizacion_verificada: 'Autorización verificada',
        autorizacion_fallida: 'Verificación fallida',
        autorizacion_expirada: 'Autorización expirada',
        autorizacion_revocada_o_invalida: 'Autorización revocada o inválida',
      };
      return labels[value] || 'Sin estado';
    },
    formatBheEmissionStatus(value) {
      const labels = {
        pending_authorization: 'Pendiente autorización',
        ready_to_emit: 'Lista para emitir',
        emitting: 'Emitiendo',
        emitted: 'Emitida',
        send_email_pending: 'Emitida sin email',
        failed: 'Con error',
        skipped: 'No aplica',
        cancelled: 'Anulada',
      };
      return labels[value] || 'Sin estado';
    },
    getBheEmissionBadgeClass(value) {
      if (value === 'emitted' || value === 'send_email_pending') return 'badge badge-green';
      if (value === 'ready_to_emit') return 'badge badge-yellow';
      if (value === 'pending_authorization' || value === 'failed' || value === 'cancelled') return 'badge badge-red';
      return 'badge badge-gray';
    },
    getGroupBheRows(group) {
      return ((group && group.pagos) || [])
        .map((wrap) => {
          const bhe = (wrap && wrap.bhe) || null;
          if (bhe) {
            return {
              ...bhe,
              service_value: wrap.service_value,
              bhe_retencion_monto: wrap.bhe_retencion_monto,
              bhe_retencion_monto_calculado: wrap.bhe_retencion_monto_calculado,
              bhe_retencion_jobbing_enabled: wrap.bhe_retencion_jobbing_enabled,
              monto_neto_post_bhe_display: wrap.monto_neto_post_bhe_display,
            };
          }
          if (Number(wrap.service_value || 0) <= 0) {
            return {
              pago_id: wrap && wrap.pago ? wrap.pago.id : null,
              estado: 'skipped',
              service_value: wrap.service_value,
              retencion_monto: 0,
              bhe_retencion_monto_calculado: wrap.bhe_retencion_monto_calculado,
              bhe_retencion_jobbing_enabled: wrap.bhe_retencion_jobbing_enabled,
              monto_neto_post_bhe_display: wrap.monto_neto_post_bhe_display,
              error_mensaje: 'Pago compuesto solo por insumos.',
            };
          }
          return {
            pago_id: wrap && wrap.pago ? wrap.pago.id : null,
            estado: 'pending_authorization',
            service_value: wrap.service_value,
            retencion_monto: wrap.bhe_retencion_monto,
            bhe_retencion_monto_calculado: wrap.bhe_retencion_monto_calculado,
            bhe_retencion_jobbing_enabled: wrap.bhe_retencion_jobbing_enabled,
            monto_neto_post_bhe_display: wrap.monto_neto_post_bhe_display,
            error_mensaje: 'Aún no hay tracking BHE para este pago.',
          };
        });
    },
    getBheRetencionMontoInformativo(row) {
      if (!row) return 0;
      const calculated = Number(row.bhe_retencion_monto_calculado);
      if (Number.isFinite(calculated) && calculated > 0) {
        return calculated;
      }
      return Number(row.retencion_monto || row.bhe_retencion_monto || 0);
    },
    getProfBheRetencionTotal(prof) {
      return (((prof && prof.pagos) || [])).reduce(
        (acc, wrap) => (wrap.checked ? acc + Number(wrap.bhe_retencion_monto || 0) : acc),
        0,
      );
    },
    getOrderBheRetencionTotal(group) {
      return (((group && group.pagos) || [])).reduce(
        (acc, wrap) => (wrap.checked ? acc + Number(wrap.bhe_retencion_monto || 0) : acc),
        0,
      );
    },
    openBhePdf(row) {
      if (row && row.pdf_url) {
        window.open(row.pdf_url, '_blank');
      }
    },
    hasEmittedBhe(wrap) {
      const bhe = wrap && wrap.bhe ? wrap.bhe : null;
      if (!bhe) {
        return false;
      }
      return ['emitted', 'send_email_pending'].includes(bhe.estado);
    },
    groupHasEmittedBhe(group) {
      return ((group && group.pagos) || []).some((wrap) => this.hasEmittedBhe(wrap));
    },
    getItemDocumento(itemId, group) {
      const docs = this.getDocumentosServicio(group);
      const tipos = [];
      docs.forEach((doc) => {
        const ids = Array.isArray(doc.item_ids) ? doc.item_ids : [];
        if (ids.includes(itemId)) {
          if (doc.tipo_documento === 'factura' && !tipos.includes('Factura')) tipos.push('Factura');
          if (doc.tipo_documento === 'boleta' && !tipos.includes('Boleta')) tipos.push('Boleta');
        }
      });
      return tipos.length ? tipos.join(' / ') : 'Sin documento';
    },
    getItemPorcentajePagado(itemId, itemPrecio, group) {
      const porcentaje = this.getItemPorcentajePagadoValue(itemId, itemPrecio, group);
      if (!Number.isFinite(porcentaje) || porcentaje <= 0) {
        return '0%';
      }
      return `${Math.round(porcentaje * 10) / 10}%`;
    },
    getItemPorcentajePagadoValue(itemId, itemPrecio, group) {
      const precio = Number(itemPrecio || 0);
      if (!precio) {
        return 0;
      }

      const itemPaidTotals = (group && group.orden && group.orden.item_paid_totals) || {};
      const totalPagadoDesdeBackend = Number(itemPaidTotals[itemId] ?? itemPaidTotals[String(itemId)]);
      if (Number.isFinite(totalPagadoDesdeBackend) && totalPagadoDesdeBackend >= 0) {
        const porcentajeBackend = (totalPagadoDesdeBackend / precio) * 100;
        return Number.isFinite(porcentajeBackend) && porcentajeBackend > 0 ? porcentajeBackend : 0;
      }

      let totalPagado = 0;
      (group.pagos || []).forEach((wrap) => {
        const detalles = wrap && wrap.solicitud_pago && Array.isArray(wrap.solicitud_pago.detalles)
          ? wrap.solicitud_pago.detalles
          : [];
        detalles.forEach((detalle) => {
          if (Number(detalle.item_id) === Number(itemId)) {
            totalPagado += Number(detalle.monto || 0);
          }
        });
      });
      const porcentaje = (totalPagado / precio) * 100;
      if (!Number.isFinite(porcentaje) || porcentaje <= 0) {
        return 0;
      }
      return porcentaje;
    },
    getPorcentajeBadgeClass(itemId, itemPrecio, group) {
      const porcentaje = this.getItemPorcentajePagadoValue(itemId, itemPrecio, group);
      if (porcentaje <= 0) {
        return 'badge badge-gray';
      }
      if (porcentaje >= 100) {
        return 'badge badge-green';
      }
      return 'badge badge-yellow';
    },
    getDocumentoBadgeClass(itemId, group) {
      const doc = this.getItemDocumento(itemId, group);
      return doc === 'Sin documento' ? 'badge badge-gray' : 'badge badge-green';
    },
    abrirDocumento(doc) {
      if (!doc || !doc.id) {
        return;
      }
      axios.post(`${window.hostname}/api/superadmin/obtener_link_archivo_orden`, { archivo_id: doc.id })
        .then((response) => {
          if (response.data && response.data.link) {
            window.open(response.data.link, '_blank');
          }
        })
        .catch((error) => {
          console.error('No se pudo abrir el archivo del documento:', error);
        });
    },
    openRefundCreateModal(wrap) {
      if (!wrap || !wrap.pago) {
        return;
      }
      const availableAmount = Number(wrap.remaining_refundable_amount || 0);
      if (availableAmount <= 0) {
        return;
      }
      this.refundCreateModal = {
        show: true,
        wrap,
      };
      this.refundCreateForm = {
        monto: availableAmount,
        motivo: '',
        notas_internas: '',
        email_cliente: '',
        send_email: true,
      };
    },
    closeRefundCreateModal(force = false) {
      if (this.refundCreateSubmitting && !force) {
        return;
      }
      this.refundCreateModal = {
        show: false,
        wrap: null,
      };
      this.refundCreateForm = {
        monto: null,
        motivo: '',
        notas_internas: '',
        email_cliente: '',
        send_email: true,
      };
    },
    async submitRefundCreate() {
      const wrap = this.refundCreateModal.wrap;
      if (!wrap || !wrap.pago) {
        return;
      }
      const availableAmount = Number(wrap.remaining_refundable_amount || 0);
      const refundAmount = Math.floor(Number(this.refundCreateForm.monto || 0));
      const motivo = String(this.refundCreateForm.motivo || '').trim();
      if (refundAmount <= 0 || refundAmount > availableAmount) {
        window.alert(`Debes ingresar un monto válido hasta $${this.formatCurrency(availableAmount)}.`);
        return;
      }
      if (!motivo) {
        window.alert('Debes ingresar un motivo para el reembolso.');
        return;
      }

      this.refundCreateSubmitting = true;
      try {
        const response = await axios.post(`${window.hostname}/api/superadmin/refunds`, {
          motivo,
          notas_internas: this.refundCreateForm.notas_internas || null,
          email_cliente: this.refundCreateForm.email_cliente || null,
          send_email: !!this.refundCreateForm.send_email,
          items: [
            {
              pago_id: wrap.pago.id,
              monto_reembolso_cliente: refundAmount,
            },
          ],
        });
        const emailError = response && response.data ? response.data.email_error : null;
        this.closeRefundCreateModal(true);
        await this.initialize_();
        if (emailError) {
          window.alert(emailError);
        }
      } catch (error) {
        console.error('No se pudo crear el reembolso:', error);
        const message = error && error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : 'No se pudo crear el reembolso.';
        window.alert(message);
      } finally {
        this.refundCreateSubmitting = false;
      }
    },
    isOrderBlocked(group) {
      const pagos = group.pagos || [];
      const presupuestos = (group.orden && group.orden.presupuestos) || [];
      if (this.isPresupuestoNoRequerido(group) || this.isPurchasedSolicitud(group)) {
        return false;
      }
      return pagos.length === 1 && Number(pagos[0].pago.monto || 0) < 25000 && presupuestos.length === 0;
    },
    isPresupuestoNoRequerido(group) {
      return !!(group && group.orden && group.orden.presupuesto_no_requerido);
    },
    isPurchasedSolicitud(group) {
      if (group && group.orden && group.orden.solicitud_comprada) {
        return true;
      }
      return ((group && group.pagos) || []).some(
        (wrap) => !!(wrap && wrap.purchased_solicitud_commission_applied),
      );
    },
    hasCheckedBlockedPayments(group) {
      return this.isOrderBlocked(group) && (group.pagos || []).some((wrap) => !!wrap.checked);
    },
    applyTransferRules() {
      this.profesionales.forEach((prof) => {
        this.groupedByOrder(prof).forEach((group) => {
          group.pagos.forEach((wrap) => {
            if (Number(wrap.monto_neto_ajustado_display || 0) <= 0) {
              wrap.checked = false;
              return;
            }
            if (this.shouldRequireBheForTransfer(prof) && !this.hasEmittedBhe(wrap)) {
              wrap.checked = false;
            }
          });
          if (this.isPresupuestoNoRequerido(group) || this.isPurchasedSolicitud(group)) {
            group.pagos.forEach((wrap) => {
              const hasPositiveNet = Number(wrap.monto_neto_ajustado_display || 0) > 0;
              if (this.shouldRequireBheForTransfer(prof) && !this.hasEmittedBhe(wrap)) {
                wrap.checked = false;
                return;
              }
              wrap.checked = hasPositiveNet;
            });
            return;
          }
          if (this.isOrderBlocked(group)) {
            group.pagos.forEach((wrap) => {
              wrap.checked = false;
            });
          }
        });
      });
    },
    getMontoTransferible(prof) {
      const selectedNet = (prof.pagos || []).reduce(
        (acc, wrap) => (wrap.checked ? acc + Number(wrap.monto_neto_ajustado_display || 0) : acc),
        0,
      );
      return Math.max(selectedNet - Number(prof.refund_outstanding_balance || 0), 0);
    },
    getOrderTransferible(group) {
      return (group.pagos || []).reduce(
        (acc, wrap) => (wrap.checked ? acc + Number(wrap.monto_neto_ajustado_display || 0) : acc),
        0,
      );
    },
    openTransferModal(prof) {
      this.modalData = {
        profesional: { ...(prof.profesional || {}) },
        pagos: [...(prof.pagos || [])],
        bancos: this.bancos || [],
        tipos_de_cuenta: this.tipos_de_cuenta || [],
        monto: this.getMontoTransferible(prof),
      };
      this.$nextTick(() => {
        this.$refs.modaltransferir.show();
      });
    },
    async initialize_() {
      this.loaded = false;
      try {
        const response = await axios.get(`${window.hostname}/api/superadmin/get_pendientes_detalle`);
        this.profesionales = Array.isArray(response.data.profesionales) ? response.data.profesionales : [];
        this.bheRetencionJobbingEnabled = !!response.data.bhe_retencion_jobbing_enabled;
        this.bancos = response.data.bancos || [];
        this.tipos_de_cuenta = response.data.tipos_de_cuenta || [];
        this.applyTransferRules();
      } catch (e) {
        console.error('Error al cargar detalle de pagos:', e);
        this.profesionales = [];
      } finally {
        this.loaded = true;
      }
    },
    downloadCSV() {
      if (!this.selectedPaymentIds.length) {
        return;
      }
      axios({
        method: 'POST',
        url: `${window.hostname}/api/superadmin/generate_transfer_csv_selected`,
        responseType: 'blob',
        data: { pagos_ids: this.selectedPaymentIds },
      })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'text/csv;charset=utf-8;' });
          const link = document.createElement('a');
          if (link.download !== undefined) {
            const blobUrl = URL.createObjectURL(blob);
            link.setAttribute('href', blobUrl);
            link.setAttribute('download', 'transfers_selected.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch((error) => {
          console.error('Error downloading selected CSV file:', error);
        });
    },
  },
  computed: {
    ...mapGetters(['admin_datos']),
    totalVenta() {
      return this.profesionales.reduce((sum, prof) => sum + Number(prof.monto_total_ordenes || 0), 0);
    },
    totalAPagar() {
      return this.profesionales.reduce((sum, prof) => sum + this.getMontoTransferible(prof), 0);
    },
    selectedPaymentIds() {
      const ids = [];
      this.profesionales.forEach((prof) => {
        (prof.pagos || []).forEach((wrap) => {
          if (wrap.checked && wrap.pago && wrap.pago.id) {
            ids.push(wrap.pago.id);
          }
        });
      });
      return ids;
    },
  },
  mounted() {
    if (!this.admin_datos.superadmin) {
      this.$router.push('/');
    }
    this.$root.$on('update-pagos', () => {
      this.initialize_();
    });
  },
};
</script>

<style scoped>
.table-shell { overflow-x: auto; }
.top-actions { display: flex; justify-content: flex-end; margin-bottom: 10px; }
.main-table { width: 100%; border-collapse: separate; border-spacing: 0 10px; }
.main-table thead th { background: #263543; color: white; padding: 12px; font-size: 13px; text-transform: uppercase; letter-spacing: .03em; }
.main-table tbody tr.professional-row { background: #fff; box-shadow: 0 2px 8px rgba(38,53,67,.08); }
.main-table td { padding: 12px; vertical-align: middle; }
.professional-cell { display: flex; gap: 10px; align-items: center; }
.prof-name { font-weight: 700; display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.prof-meta { color: #6b7280; font-size: 12px; }
.person-img { width: 42px; height: 42px; border-radius: 50%; object-fit: cover; }
.professional-tax-badge { font-size: 11px; }
.expand-btn { width: 30px; height: 30px; border-radius: 999px; border: 1px solid #d1d5db; background: white; font-weight: 700; }
.transfer-btn { background: #008cba; color: white; border: 0; padding: 8px 14px; border-radius: 6px; font-weight: 600; }
.transfer-btn:disabled { background: #9bb9c4; }
.detail-row td { padding: 0; }
.detail-container { background: #f6f8fb; border: 1px solid #e5eaf0; border-top: 0; padding: 14px !important; }
.order-card { background: white; border: 1px solid #e6ebf1; border-radius: 10px; padding: 12px; margin-bottom: 12px; }
.order-header { display: flex; justify-content: space-between; gap: 10px; align-items: flex-start; }
.order-header h4 { margin: 0; font-size: 16px; }
.order-header p { margin: 2px 0 0; color: #64748b; }
.inline-detail-link { color: #0369a1; font-weight: 700; text-decoration: none; }
.inline-detail-link:hover { color: #075985; text-decoration: underline; }
.order-total { font-size: 12px; font-weight: 700; color: #334155; }
.order-warning { margin-top: 8px; padding: 8px; background: #fff7ed; border: 1px solid #fed7aa; color: #9a3412; border-radius: 6px; }
.order-warning-strong { background: #fef2f2; border-color: #fecaca; color: #991b1b; font-weight: 700; }
.order-info { margin-top: 8px; padding: 8px; background: #ecfeff; border: 1px solid #a5f3fc; color: #155e75; border-radius: 6px; }
.grid-two { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 10px; }
.detail-card { border: 1px solid #edf1f6; border-radius: 8px; padding: 10px; }
.detail-card h5 { margin: 0 0 8px; font-size: 13px; text-transform: uppercase; color: #334155; }
.clean-list { margin: 0; padding-left: 16px; }
.doc-section + .doc-section { margin-top: 12px; }
.doc-section-title { font-size: 12px; font-weight: 700; color: #475569; margin-bottom: 6px; text-transform: uppercase; }
.doc-total { margin-top: 8px; font-weight: 700; color: #1e293b; }
.doc-warning { background: #fff1f2; border: 1px solid #fecdd3; color: #9f1239; border-radius: 6px; padding: 8px; }
.doc-info { background: #eff6ff; border: 1px solid #bfdbfe; color: #1d4ed8; border-radius: 6px; padding: 8px; }
.doc-row { display: flex; justify-content: space-between; gap: 10px; align-items: center; margin-bottom: 6px; }
.doc-link-btn { background: #0f766e; color: #fff; border: 0; border-radius: 6px; padding: 4px 8px; font-size: 12px; }
.refund-btn { background: #b91c1c; color: #fff; border: 0; border-radius: 6px; padding: 4px 8px; font-size: 12px; }
.refund-btn:hover { background: #991b1b; }
.refund-btn:disabled { background: #cbd5e1; cursor: not-allowed; }
.amount-hint { margin-top: 4px; font-size: 11px; color: #64748b; }
.amount-hint-warning { color: #b45309; font-weight: 600; }
.commission-hint { color: #334155; font-weight: 700; }
.payment-discount-hint { margin-top: 4px; font-size: 12px; font-weight: 700; color: #15803d; }
.bhe-section { border-top: 1px dashed #dbe4ee; padding-top: 10px; }
.bhe-meta-line { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-bottom: 8px; }
.bhe-sii-status { font-size: 12px; color: #475569; }
.bhe-list { padding-left: 0; list-style: none; }
.bhe-row { display: flex; justify-content: space-between; gap: 10px; align-items: flex-start; padding: 8px 0; border-top: 1px solid #eef2f7; }
.bhe-row:first-child { border-top: 0; padding-top: 0; }
.bhe-row-title { font-weight: 700; color: #1e293b; display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.refund-inline-meta { margin-top: 4px; font-size: 11px; color: #64748b; }
.inner-table { width: 100%; border-collapse: collapse; }
.inner-table td { border: 1px solid #e2e8f0; padding: 8px; }
.labels-row td { background: #f8fafc; }
.badge { padding: 2px 8px; border-radius: 999px; font-size: 12px; font-weight: 700; }
.badge-insumo { background: #dcfce7; color: #166534; }
.badge-no-insumo { background: #e2e8f0; color: #334155; }
.badge-gray { background: #e5e7eb; color: #374151; }
.badge-yellow { background: #fef3c7; color: #92400e; }
.badge-green { background: #dcfce7; color: #166534; }
.badge-red { background: #fee2e2; color: #991b1b; }
.total-row td { background: #eef2ff; font-weight: 700; }
.muted { color: #6b7280; font-style: italic; }
.column-right { background-color: rgb(242, 247, 251); padding-top: 80px; padding-left: 260px; width: 100%; }
.main-container { background-color: white; margin-top: 10px; padding: 20px 20px 10px 20px; }

.confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.confirm-modal {
  width: min(92vw, 430px);
  background: #fff;
  border-radius: 10px;
  padding: 18px;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.3);
}
.confirm-modal h4 {
  margin: 0 0 8px;
}
.confirm-modal p {
  margin: 0 0 14px;
}
.refund-modal {
  width: min(92vw, 560px);
}
.refund-modal-summary {
  color: #475569;
}
.refund-modal-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 12px;
}
.refund-modal-grid label,
.refund-modal-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.refund-modal-grid input,
.refund-modal-field input,
.refund-modal-field textarea {
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 8px 10px;
}
.refund-modal-checkbox {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 14px;
}
.confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.confirm-cancel-btn,
.confirm-ok-btn {
  border: 0;
  border-radius: 6px;
  padding: 7px 10px;
}
.confirm-cancel-btn {
  background: #e5e7eb;
  color: #111827;
}
.confirm-ok-btn {
  background: #b91c1c;
  color: #fff;
}

@media (max-width: 900px) {
  .grid-two { grid-template-columns: 1fr; }
  .column-right { padding-left: 0; }
  .refund-modal-grid { grid-template-columns: 1fr; }
}
</style>
